module.exports = __webpack_public_path__ + "static/media/experience-background-desktop.28b17b5f.jpg";